export default {
  "gemGoodsTypeAdmin.thead.index": "#NO",
  "gemGoodsTypeAdmin.thead.sort": "Sort",
  "gemGoodsTypeAdmin.thead.typeName": "TypeName",
  "gemGoodsTypeAdmin.thead.typeId": "TypeId",
  "gemGoodsTypeAdmin.thead.unit": "Unit",
  "gemGoodsTypeAdmin.thead.isRealGoods": "IsRealGoods",
  "gemGoodsTypeAdmin.thead.createdAt": "CreatedAt",
  "gemGoodsTypeAdmin.thead.updatedAt": "UpdatedAt",

  "gemGoodsTypeAdmin.add": "Add",
  "gemGoodsTypeAdmin.edit": "Edit",
  "gemGoodsTypeAdmin.details": "Details",
  "gemGoodsTypeAdmin.delete": "Delete",

  "gemGoodsTypeAdmin.thead.action": "Action",
};
